import { combineReducers } from 'redux';

import sidebar, { UiSidebarState } from './sidebar';
import appBar, { AppBarType } from './appBar';
import icCard, { ICCardStateType } from './icCard';
import recorder, { recorderStateType } from './timeRecorder';
export interface UiState {
  sidebar: UiSidebarState;
  appBar: AppBarType,
  icCard: ICCardStateType,
  recorder: recorderStateType
}

const reducer = combineReducers<UiState>({ sidebar, appBar, icCard, recorder });

export default reducer;
